import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const CertificationIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 23 23" {...props}>
      <path
        d="M11.637 7.09129C13.5658 7.09129 15.4157 7.85752 16.7796 9.22142C18.1435 10.5853 18.9097 12.4352 18.9097 14.364C18.9097 16.2929 18.1435 18.1427 16.7796 19.5066C15.4157 20.8705 13.5658 21.6367 11.637 21.6367C9.70814 21.6367 7.85829 20.8705 6.49439 19.5066C5.13049 18.1427 4.36426 16.2929 4.36426 14.364C4.36426 12.4352 5.13049 10.5853 6.49439 9.22142C7.85829 7.85752 9.70814 7.09129 11.637 7.09129ZM11.637 10.2731L10.4343 12.7095L7.74608 13.1004L9.69153 14.9958L9.23244 17.674L11.637 16.4095L14.0415 17.6731L13.5824 14.9958L15.5279 13.0995L12.8397 12.7086L11.637 10.2731ZM12.5461 2.54492L17.0915 2.54583V5.2731L15.8524 6.30765C14.8242 5.76818 13.7016 5.43204 12.5461 5.31765V2.54583V2.54492ZM10.7279 2.54492V5.31765C9.57275 5.43187 8.45046 5.7677 7.42244 6.30674L6.18244 5.2731V2.54583L10.7279 2.54492Z"
        fill={colors.primary}
      />
    </SvgIcon>
  );
};

export default CertificationIcon;
